<template>
  <div>
    <el-dialog
      title="新增淘宝小程序-天猫券"
      :visible.sync="dialogVisible"
      :width="'1000px'"
      :before-close="handleClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="closedFun"
    >
      <div class="dialog-alert">
        <strong>说明：</strong>
        <p>
          1、天猫券在市场价的基础上使用。
        </p>
        <p>2、使用优惠券购票产生的优惠差额，将由您自己承担。</p>
        <p>
          3、佣金计算：用户使用天猫券购票，平台先按平台折扣价作为用户支付价计算出您的原始佣金，再减去天猫券金额，得出您最终的佣金。
        </p>
        <p class="dialog-alert_grey">
          例：市场价100元，平台折扣价90元(比市场价优惠10元)，用户使用20元优惠券购票(比市场价优惠20元)，则您的佣金=按平台折扣价90元计算得出的您的原始佣金 - 天猫券金额（20元）。
        </p>
      </div>
      <el-form
        label-width="120px"
        style="margin-top: 20px; width: 100%"
        :model="form"
        ref="formRef"
        :rules="rules"
        :disabled="isCheckLook"
      >
        <el-form-item label="优惠券名称" prop="name">
          <el-input v-model="form.name" maxlength="10" show-word-limit placeholder="10个字以内" style="width: 800px"></el-input>
        </el-form-item>
        <el-form-item
          label="可用影院"
          prop="cinemaStandardStr"
          class="cinemaStand-item"
        >
          <el-tooltip
            class="item"
            effect="dark"
            :content="form.cinemaStandardStr"
            placement="top-start"
            popper-class="tool-tipgz"
          >
            <el-input
              v-model="form.cinemaStandardStr"
              placeholder="请筛选影院"
              disabled
              style="width: 400px"
            ></el-input>
          </el-tooltip>
          <span type="warning" class="cinemaStandBtn" @click="cinemaStandBtn"
            >筛选影院</span
          >
        </el-form-item>
        <el-form-item label="库存" prop="stock">
          <el-input v-model="form.stock" style="width: 200px">
            <template slot="append">张</template>
          </el-input>
        </el-form-item>
        <el-form-item label="面值" prop="originalPrice">
          <el-input v-model="form.originalPrice" style="width: 200px">
            <template slot="append">元</template>
          </el-input>
        </el-form-item>
        <el-form-item label="售价" prop="sellPrice">
          <el-input v-model="form.sellPrice" style="width: 200px">
            <template slot="append">元</template>
          </el-input>
        </el-form-item>
        <el-form-item label="适用位置" prop="useCondition">
          <el-select v-model="form.useCondition" placeholder="请选择适用位置">
            <el-option v-for="item in useConditionList" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
          <span style="margin-left: 10px;">座</span>
        </el-form-item>
        <el-form-item label="用户使用期限" prop="timeArr">
          <el-date-picker
            v-model="form.timeArr"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            type="datetimerange"
            align="right"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            range-separator="至"
            :default-time="['00:00:00', '23:59:59']">
          </el-date-picker>
          <!-- <el-date-picker
            v-model="form.timeArr"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd HH:mm:ss"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="changeTimesValue"
          >
          </el-date-picker> -->
        </el-form-item>
      </el-form>
      <div class="btns-coantainer">
        <el-button :loading="submitLoading" type="warning" @click="submit" v-if="!isCheckLook"
          >确认</el-button
        >
        <el-button type="warning" plain @click="onCancel">取消</el-button>
      </div>
    </el-dialog>
    <!-- 筛选影院 -->
    <filter-cinema
      v-if="cinemaVisible"
      v-model="cinemaVisible"
      @selectCinema="selectCinema"
      :ids="form.cinemaClassifyId"
      :types="form.cinemaFilterType"
      :isDisable="isCheckLook"
      @close="cinemaVisible = false"
    />
  </div>
</template>

<script>
import filterCinema from "../../coupon/FilterCinema.vue";
import {deepClone} from '@/utils/tool.js'
import mini from "@/api/mini";
const MiniModel = new mini();
let defaultForm = {
  cinemaStandardStr: "全部影院",
  cinemaClassifyId:[], //选中的影院
  cinemaFilterType: 0, //0:全部影院 1:指定影院分类

  name: "",
  stock: "", //库存
  originalPrice: "", //面值
  sellPrice: "", //售价
  useCondition: "", //适用位置
  timeArr: [], //可用时间
}
export default {
  components:{filterCinema},
  data() {
    return {
      isCheckLook:false,
      dialogVisible: false,
      submitLoading: false,
      rules: {
        name: [
          {
            required: true,
            message: "请输入优惠券名称",
            trigger: ["blur", "change"],
          },
        ],
        timeArr: [
          {
            required: true,
            message: "请选择用户使用期限",
            trigger: ["blur", "change"],
          },
        ],
        stock: [
          {
            required: true,
            message: "请输入库存",
            trigger: ["blur", "change"],
          },
          {
            validator: (rule, value, callback) => {
              if (!/^\+?[1-9]\d*$/.test(value)) {
                callback(new Error("请输入正整数"));
              } else {
                callback();
              }
            },
          },
        ],
        originalPrice: [
          {
            required: true,
            message: "请输入面值",
            trigger: ["blur", "change"],
          },
          {
            validator: (rule, value, callback) => {
              if (!/^\+?[1-9]\d*$/.test(value)) {
                callback(new Error("请输入正整数"));
              } else {
                callback();
              }
            },
          },
        ],
        sellPrice: [
          {
            required: true,
            message: "请输入售价",
            trigger: ["blur", "change"],
          },
          {
            validator: (rule, value, callback) => {
              if (!/^(?!0+(\.0+)?$)(\d+(\.\d{1,2})?)$/.test(value)) {
                callback(new Error("请输入正数，最多2位小数"));
              } else {
                callback();
              }
            },
          },
        ],
        useCondition: [
          {
            required: true,
            message: "请选择适用位置",
            trigger: ["blur", "change"],
          },
        ],
      },
      form: {
      },
      cinemaVisible: false, // 筛选影院
      useConditionList: [
        {
          label: "请选择",
          value: "",
        },
        {
          label: "1",
          value: 1,
        },
        {
          label: "2",
          value: 2,
        },
        {
          label: "3",
          value: 3,
        },
        {
          label: "4",
          value: 4,
        },
      ],
    };
  },
  methods: {
    submit() {
      console.log(this.form, "form");
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          let appKeyMini = localStorage.getItem("appKeyMini");
          let params=deepClone(this.form)
          // 可发放时间
          params.startTime = params.timeArr[0]
          params.endTime = params.timeArr[1]
          delete params.timeArr
          if(params.cinemaFilterType == 1) {
            // 可用影院分类Id英文逗号分隔
            params.cinemaClassifyId = params.cinemaClassifyId.join(',')
            // 可用影院分类 名称
            params.cinemaClassifyName = params.cinemaStandardStr
            delete params.cinemaStandardStr
          }else if(params.cinemaFilterType == 0) {
            params.cinemaClassifyId = ''
            params.cinemaClassifyName = ''
            delete params.cinemaStandardStr
          }

          console.log(this.form,"通过=",params);
          // return
          this.submitLoading = true
          MiniModel.tmallGoodsCreate({...params,appKey: appKeyMini}).then(res => {
            console.log(res,'创建新优惠券')
            if(res.data.code == 200) {
              this.$message.success(res.data.message);
              this.$emit('updateDy')
              this.dialogVisible = false
            }
          }).finally(()=>{
            this.submitLoading = false
          })
        } else {
          console.log("error submit!!");
        }
      });
    },
    // 选中部分,子传父
    selectCinema(arr,type) {
      console.log(arr,type,'点击确定==子传父')
      this.form.cinemaFilterType = type
      this.form.cinemaClassifyId = arr.map((item) => item.id);
      console.log( this.form.cinemaClassifyId ,' this.form.cinemaClassifyId ')
      if(type) {
        this.form.cinemaStandardStr = arr
        .map((item) => item.name)
        .join(",");
      }else{
        this.form.cinemaStandardStr = '全部影院'
      }
      console.log(this.form.cinemaStandardStr,'this.form.cinemaStandardStr')
    },
    onCancel() {
      this.closeReset();
    },
    open(row) {
      console.log(row,'openopen==')
      this.dialogVisible = true;
      if(row) {
        console.log('查看11')
        // this.dialogVisible = true;
        // 查看
        this.isCheckLook = true
        this.form = Object.assign({},defaultForm,row)
        this.form.cinemaClassifyId = row.cinemaClassifyId.split(',')
        this.form.cinemaFilterType = row.cinemaFilterType
        if(row.cinemaFilterType) {
          this.form.cinemaStandardStr = row.cinemaClassifyName
        }else{
          this.form.cinemaStandardStr = "全部影院"
        }
        this.form.timeArr = [row.startTime,row.endTime]
      }else{
        console.log('新增11')
        this.isCheckLook = false
        this.form = Object.assign({},defaultForm)
      }
      console.log(this.form,'form=open===1')
      this.dialogVisible = true;
      this.$nextTick(()=> {
        this.$refs.formRef.clearValidate();
      })
    },
    handleClose() {
      console.log("右上角取消==1");
      this.closeReset();
    },
    closedFun() {
      console.log("关闭了");
    },
    closeReset() {
      this.dialogVisible = false;
    },
    cinemaStandBtn() {
      this.cinemaVisible = true;
    },
    changeTimesValue(e) {
      console.log(e, "可发放时间");
    },
    changeRadio(e, type) {
      console.log(e, type, "event");
      if (type == "a") {
        console.log("切换优惠券类型");
        // 优惠券类型
        if (e == 1) {
          this.form.discountNow = "";
        } else if (e == 2) {
          this.form.minPayAmount = "";
          this.form.discountAmount = "";
        }
      } else if (type == "b") {
        console.log("切换用户使用期限");
        // 用户使用期限
        if (e == 1) {
          this.form.useDay = "";
        } else if (e == 2) {
          this.form.useTimeArr = [];
        }
      }
    },
  },
};
</script>

<style lang="less" scoped>
.btns-coantainer {
  margin: 30px 0 20px 120px;
}
.dialog-alert {
  display: block;
  padding: 10px;
  color: #666;
  background: #efefef;
  strong {
    display: block;
    color: #333;
  }
  p {
    display: block;
  }
  &_grey {
    color: #999;
  }
}
.cinemaStandBtn {
  margin-left: 20px;
  cursor: pointer;
  color: #ff8622;
  text-decoration: underline;
}
.type-container {
  display: flex;
  width: 450px;
  justify-content: space-between;
}
.status-text {
  color: #999;
  margin-left: 10px;
  font-size: 12px;
}
/deep/.el-range-separator {
  width: 10% !important;
}
/deep/.el-radio__input.is-checked + .el-radio__label {
  color: #333 !important;
}
/deep/.el-radio__input.is-checked .el-radio__inner {
  background: #ff8622 !important;
  border-color: #ff8622 !important;
}
/deep/.el-date-editor, .el-dialog__wrapper .el-date-editor{
  width: 400px !important;
}
</style>
<style>
.tool-tipgz {
  max-width: 600px;
}
.el-tooltip__popper {
  max-width: 60% !important;
}
</style>



// WEBPACK FOOTER //
// src/views/pc/miniProgram/couponTaoBao/component/createCoupon.vue